/** Formats a trend value for the chart tooltip and the table; no data is "—" (overview D5). */
export const NO_TREND_VALUE = "—";

export function formatTrendValue(value: number | null): string {
  return value === null ? NO_TREND_VALUE : value.toLocaleString();
}
